const hasHtml = (string = '') => {
  const pattern = /<[a-z][\s\S]*>/i;
  return pattern.test(string);
};

module.exports = hasHtml;
